import React from 'react'
import Search from './Search'
import SetupPage from 'modules/setup/SetupPage'
import TrabajoInfoTab from './trabajoInfo/TrabajoInfoTab'
import { faSquare } from '@fortawesome/free-solid-svg-icons'

const TrabajoSetup = () => {

	const setupProps = {
		title: "Trabajos",
		icon: faSquare,
		addNewTitle: "Crear trabajo",
		searchUrl: "/trabajoSetup/search",
		rowKey: "idTrabajo",
		columns: [
			{ key: "idTrabajo", name: "ID", sortable: true, width: 60 },
			{ key: "numero", name: "Numero", sortable: true },
			{ key: "cliente", name: "Empresa", sortable: false },
			{ key: "potencia", name: "Potencia", sortable: true, width: 100 },
			{ key: "marca", name: "Marca", sortable: true },
			{ key: "estado", name: "Estado", sortable: false }
		],
		tabs: [
			{ key: "info", title: "Info", comp: TrabajoInfoTab }
		]
	};

	return (
		<SetupPage
			setupProps={setupProps}
			search={Search} />
	)
}

export default TrabajoSetup;